import { toast } from 'react-toastify'
import URL from 'src/apis/URL'

// Action Types
export const GET_ORDERS_REQUEST = 'GET_ORDERS_REQUEST'
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS'
export const GET_ORDERS_FAILURE = 'GET_ORDERS_FAILURE'

export const GET_PENDING_ORDERS_REQUEST = 'GET_PENDING_ORDERS_REQUEST'
export const GET_PENDING_ORDERS_SUCCESS = 'GET_PENDING_ORDERS_SUCCESS'
export const GET_PENDING_ORDERS_FAILURE = 'GET_PENDING_ORDERS_FAILURE'

export const GET_ORDER_HISTORY_REQUEST = 'GET_ORDER_HISTORY_REQUEST'
export const GET_ORDER_HISTORY_SUCCESS = 'GET_ORDER_HISTORY_SUCCESS'
export const GET_ORDER_HISTORY_FAILURE = 'GET_ORDER_HISTORY_FAILURE'

export const GET_COMPLETED_ORDERS_REQUEST = 'GET_COMPLETED_ORDERS_REQUEST'
export const GET_COMPLETED_ORDERS_SUCCESS = 'GET_COMPLETED_ORDERS_SUCCESS'
export const GET_COMPLETED_ORDERS_FAILURE = 'GET_COMPLETED_ORDERS_FAILURE'

export const GET_CANCELLED_ORDERS_REQUEST = 'GET_CANCELLED_ORDERS_REQUEST'
export const GET_CANCELLED_ORDERS_SUCCESS = 'GET_CANCELLED_ORDERS_SUCCESS'
export const GET_CANCELLED_ORDERS_FAILURE = 'GET_CANCELLED_ORDERS_FAILURE'

// Action Creators
const getOrdersRequest = () => ({ type: GET_ORDERS_REQUEST })
const getOrdersSuccess = (data) => ({ type: GET_ORDERS_SUCCESS, data })
const getOrdersFailure = (error) => ({ type: GET_ORDERS_FAILURE, error })

const getPendingOrdersRequest = () => ({ type: GET_PENDING_ORDERS_REQUEST })
const getPendingOrdersSuccess = (data) => ({ type: GET_PENDING_ORDERS_SUCCESS, data })
const getPendingOrdersFailure = (error) => ({ type: GET_PENDING_ORDERS_FAILURE, error })

const getOrderHistoryRequest = () => ({ type: GET_ORDER_HISTORY_REQUEST })
const getOrderHistorySuccess = (data) => ({ type: GET_ORDER_HISTORY_SUCCESS, data })
const getOrderHistoryFailure = (error) => ({ type: GET_ORDER_HISTORY_FAILURE, error })

const getCompletedOrdersRequest = () => ({ type: GET_COMPLETED_ORDERS_REQUEST })
const getCompletedOrdersSuccess = (data) => ({ type: GET_COMPLETED_ORDERS_SUCCESS, data })
const getCompletedOrdersFailure = (error) => ({ type: GET_COMPLETED_ORDERS_FAILURE, error })

const getCancelledOrdersRequest = () => ({ type: GET_CANCELLED_ORDERS_REQUEST })
const getCancelledOrdersSuccess = (data) => ({ type: GET_CANCELLED_ORDERS_SUCCESS, data })
const getCancelledOrdersFailure = (error) => ({ type: GET_CANCELLED_ORDERS_FAILURE, error })

// API Calls
const fetchOrders = (endpoint, requestAction, successAction, failureAction) => {
  return (dispatch) => {
    dispatch(requestAction())
    fetch(URL.BASE_URL + endpoint, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((data) => {
        dispatch(successAction(data))
      })
      .catch((error) => {
        dispatch(failureAction(error.message))
        toast.error(error.message)
      })
  }
}

// Thunk Actions
export const getAllOrders = () =>
  fetchOrders(URL.END_POINT.allOrders, getOrdersRequest, getOrdersSuccess, getOrdersFailure)
export const getPendingOrders = () =>
  fetchOrders(
    URL.END_POINT.pendingOrders,
    getPendingOrdersRequest,
    getPendingOrdersSuccess,
    getPendingOrdersFailure,
  )
export const getOrderHistory = () =>
  fetchOrders(
    URL.END_POINT.orderHistory,
    getOrderHistoryRequest,
    getOrderHistorySuccess,
    getOrderHistoryFailure,
  )
export const getCompletedOrders = () =>
  fetchOrders(
    URL.END_POINT.completedOrders,
    getCompletedOrdersRequest,
    getCompletedOrdersSuccess,
    getCompletedOrdersFailure,
  )
export const getCancelledOrders = () =>
  fetchOrders(
    URL.END_POINT.cancelledOrders,
    getCancelledOrdersRequest,
    getCancelledOrdersSuccess,
    getCancelledOrdersFailure,
  )

// Reducer
const initialState = {
  allOrders: [],
  pendingOrders: [],
  orderHistory: [],
  completedOrders: [],
  cancelledOrders: [],
  loading: false,
  error: null,
}

export const ordersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ORDERS_REQUEST:
    case GET_PENDING_ORDERS_REQUEST:
    case GET_ORDER_HISTORY_REQUEST:
    case GET_COMPLETED_ORDERS_REQUEST:
    case GET_CANCELLED_ORDERS_REQUEST:
      return { ...state, loading: true, error: null }

    case GET_ORDERS_SUCCESS:
      return { ...state, allOrders: action.data.orders, loading: false, error: null }
    case GET_PENDING_ORDERS_SUCCESS:
      return { ...state, pendingOrders: action.data.data, loading: false, error: null }
    case GET_ORDER_HISTORY_SUCCESS:
      return { ...state, orderHistory: action.data.history, loading: false, error: null }
    case GET_COMPLETED_ORDERS_SUCCESS:
      return { ...state, completedOrders: action.data.completed, loading: false, error: null }
    case GET_CANCELLED_ORDERS_SUCCESS:
      return { ...state, cancelledOrders: action.data.cancelled, loading: false, error: null }

    case GET_ORDERS_FAILURE:
    case GET_PENDING_ORDERS_FAILURE:
    case GET_ORDER_HISTORY_FAILURE:
    case GET_COMPLETED_ORDERS_FAILURE:
    case GET_CANCELLED_ORDERS_FAILURE:
      return { ...state, loading: false, error: action.error }

    default:
      return state
  }
}
